package com.dotpx.ambient

data class AmbientControllerState(
    val playback: AmbiencePlaybackSnapshot = AmbiencePlaybackSnapshot(),
    val visualization: AmbienceVisualFrame = AmbienceVisualFrame.Idle,
    val previewVisible: Boolean = false,
    val previewing: SoundPreviewItem? = null,
)
